import React, { createContext, useState, useEffect } from "react";
import { UserProp } from "./../User/UserAPI";
import * as Storage from "ts-storage";
import { getDataFromToken } from "../../utils/tokenAPI";

interface FlashMessageProp {
  type: string;
  msg: string;
  show: boolean;
}

export const AuthContext = createContext<any>(null);

// store user id, and user profile

export default function AuthProvider(props: any) {
  const [isAuth, setAuth] = useState<boolean>(false);
  const [user, setUser] = useState<UserProp | null>(null);
  const [loading, setLoading] = useState(true);
  const [flashMessage, setFlashMessage] = useState<FlashMessageProp>({
    type: "",
    msg: "",
    show: false,
  });

  useEffect(() => {
    setLoading(true);
    let fallback: string = "error";
    const token = Storage.get("token", fallback).value;

    if (token !== fallback) {
      getDataFromToken(token)
        .then((res: any) => {
          setLoading(false);
          setAuth(true);
          setUser(res);
          setLoading(false);
        })
        .catch((err) => {
          setFlashMessage({
            type: "danger",
            msg: "Error Fetching user data",
            show: true,
          });
          setAuth(false);
          setUser(null);
          setLoading(false);
        });
    } else {
      setAuth(false);
      setUser(null);
      setLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={[
        isAuth,
        setAuth,
        user,
        setUser,
        flashMessage,
        setFlashMessage,
        loading,
        setLoading,
      ]}
    >
      {props.children}
    </AuthContext.Provider>
  );
}
